import { render, staticRenderFns } from "./detail-disbursement.vue?vue&type=template&id=34ae4e70&scoped=true"
import script from "./detail-disbursement.vue?vue&type=script&lang=js"
export * from "./detail-disbursement.vue?vue&type=script&lang=js"
import style0 from "./detail-disbursement.vue?vue&type=style&index=0&id=34ae4e70&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ae4e70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34ae4e70')) {
      api.createRecord('34ae4e70', component.options)
    } else {
      api.reload('34ae4e70', component.options)
    }
    module.hot.accept("./detail-disbursement.vue?vue&type=template&id=34ae4e70&scoped=true", function () {
      api.rerender('34ae4e70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/online-transaction/detail-disbursement.vue"
export default component.exports